import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { STCountryArray } from "@/app/common-types/quote/question-payload-type";
import { QuotePayload } from "@/app/common-types/quote/quote-data";
import { TripDetails } from "@/app/common-types/quote/trip-details";
import { modifyPayloadSave } from "@/app/common-utils/common.utils";
import { useQuestionsState } from "@/providers/questions-state-provider";
import { RootState } from "@/store/root-reducer";
import { getQuestionTwoState } from "@/utils/question-location-to.utils";

import { useLocationTo } from "../provider/location-to-provider";

type LocationToDataProps = {
  tripDetails: TripDetails | undefined;

  selectedpolicyType: string | undefined;
  toLocationCountryDetails: STCountryArray | undefined;
};

const useLocationToData = ({
  tripDetails,
  selectedpolicyType,
  toLocationCountryDetails,
}: LocationToDataProps) => {
  const [questionState, setQuestionState] = useState<{
    fromCountrySelected: string | null;
    toCountrySelected: string | null;
    valueSelected: string | null;
    countryArray: [];
  }>({
    fromCountrySelected: null,
    toCountrySelected: null,
    valueSelected: null,
    countryArray: [],
  });
  const { toCountrySelected } = questionState;
  const [selectedAMTEuropeWorldwide, setSelectedAMTEuropeWorldwide] = useState<
    string | undefined
  >(undefined);
  const { setPayload } = useLocationTo();
  const quoteResponse = useSelector(
    (state: RootState) => state.quote
  ) as QuotePayload;
  const { selected } = useQuestionsState();

  const modifyPayloadToLocation = useCallback(
    (
      fromLocation?: string | undefined,
      toLocation?: string | undefined,
      area?: string | undefined,
      stCountryList?: STCountryArray
    ) => {
      if (area) {
        // eslint-disable-next-line no-param-reassign
        toLocation = undefined;
      }
      if (toLocation) {
        // eslint-disable-next-line no-param-reassign
        area = undefined;
      }
      const tripDetailsModifiled: TripDetails = {
        ...tripDetails,
        ...{ fromLocation },
        ...{ toLocation },
        ...{ area },
        ...{ toLocationCountryDetails: stCountryList },
      };
      setPayload(modifyPayloadSave(quoteResponse, tripDetailsModifiled));
    },
    [quoteResponse, setPayload, tripDetails]
  );

  useEffect(() => {
    if (selected && selectedpolicyType) {
      const data = getQuestionTwoState(
        selected as string,
        selectedpolicyType,
        toLocationCountryDetails
      ) as {
        fromCountrySelected: string | null;
        toCountrySelected: string | null;
        valueSelected: string | null;
        countryArray: [];
      };
      setQuestionState(data);
    }
  }, [selectedpolicyType, selected, toLocationCountryDetails]);

  useEffect(() => {
    if (toCountrySelected) {
      setSelectedAMTEuropeWorldwide(toCountrySelected);
    }
  }, [toCountrySelected]);
  return {
    questionState,
    setQuestionState,
    selectedAMTEuropeWorldwide,
    setSelectedAMTEuropeWorldwide,
    modifyPayloadToLocation,
  };
};

export default useLocationToData;
